const serverUrl = `http://localhost:2000`;

function getUrl() {
  return serverUrl;
}

export default serverUrl;



// WEBPACK FOOTER //
// ./src/serverConfig.js